import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "system-notification-content"
};
import NotificaFilterBlock from "@/views/systemNotification/components/NotificaFilterBlock.vue";
import NotificaTableBlock from "@/views/systemNotification/components/NotificaTableBlock.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const NotificaTable = ref();
    const filterSubmit = params => {
      NotificaTable.value.searchData(params);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NotificaFilterBlock, {
        onFilterSubmit: filterSubmit
      }), _createVNode(NotificaTableBlock, {
        ref_key: "NotificaTable",
        ref: NotificaTable
      }, null, 512)]);
    };
  }
});